import { Col, Row } from 'antd';
import React, { FC } from 'react';
import styles from './appComponents.module.scss';
import UploadComponent from 'shared/components/UploadComponent';
import ScopeThreeAppComponents from './ScopeThreeComponents';
import FormikFormComponent from './FormikForm';
import ReactHookFormComponent from './ReactHookForm';
import OrganizationMapComponent from './OrganizationMap';
import ButtonAppComponent from './ButtonAppComponent.index';
import UIAppComponents from './UIAppComponents';
import CommodityAPPComponent from './CommodityAppComponent';
import DistributionFormComponent from './DistributionFormComponent';
import EmptyStateAppComponent from './EmptyStateAppComponent';

interface AppComponentsProps {}

const AppComponents: FC<AppComponentsProps> = props => {
  return (
    <div className="app-components">
      <h1 className="text-center text-decoration">App Components</h1>

      <ScopeThreeAppComponents />
      <Row className={styles.reactHookForm}>
        <ReactHookFormComponent />
      </Row>
      <FormikFormComponent />

      <div className="mt-5">
        <ButtonAppComponent />

        <UIAppComponents />

        <DistributionFormComponent />

        <CommodityAPPComponent />
      </div>

      <OrganizationMapComponent />

      <Row>
        <Col span={24}>
          <UploadComponent
            name="upload"
            children={<Row>This is upload component</Row>}
            className="uploader"
          />
        </Col>
        <Col span={24}>
          <EmptyStateAppComponent />
        </Col>
      </Row>
    </div>
  );
};

export default AppComponents;
